import React from "react";

const ChevronRightIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M6.91858 5.44274C7.22326 5.14666 7.69623 5.13032 8.01947 5.38916L8.09698 5.4596L12.8447 10.3451L8.07986 14.9716C7.74967 15.2922 7.22209 15.2844 6.90148 14.9542C6.60553 14.6494 6.58939 14.1764 6.84836 13.8533L6.91884 13.7758L10.4868 10.3104L6.90172 6.62113C6.60565 6.31646 6.58931 5.84348 6.84814 5.52025L6.91858 5.44274Z" fill="#212121" />
        </svg>
    );
};

export default ChevronRightIcon;
